import { Box, styled } from '@mui/material';
import { TripArrayFieldTextField } from './TripArrayFieldTextField';

const PREFIX = 'TripArrayFieldNotesInput';
const classes = {
  container: `${PREFIX}-container`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '75%',
    },
  },
}));

export function TripArrayFieldNotesInput({
  index,
  tripField,
  label,
}: {
  index: number;
  tripField: 'pickupNotes' | 'dropoffNotes';
  label: string;
}) {
  return (
    <StyledBox className={classes.container}>
      <TripArrayFieldTextField
        tripField={tripField}
        index={index}
        label={label}
      />
    </StyledBox>
  );
}
